module Meevo.Plugins.TransactionEditor {
    export class TransactionEditorService {
        constructor(
            public dataService: Meevo.Components.BaseClasses.IDataService
        ) { }

        getDaysToEditTransaction() {
            const maxEditTransactionThreshold = 32;
            return this.dataService.customMethodData("/api/securityRole/daysToEditTransaction", "GET", null)
                .then((response) => {
                    return angular.isDefined(response.data) ? response.data : maxEditTransactionThreshold;
                })
                .catch(() => {
                    return maxEditTransactionThreshold;
                });
        }

        static factory(): Function {
            let svc = (
                dataService
            ) => new TransactionEditorService(
                dataService
            );

            svc.$inject = [
                "meevo.components.common.DataService"
            ];

            return svc;
        }
    }

    angular.module("meevo.plugins.transactionEditor")
        .factory("meevo.plugins.transactionEditor.transactionEditorService", TransactionEditorService.factory());
}